import { motion } from "framer-motion";
import { ConnectionPill } from "@/components/portal/ConnectionPill";

export const WaitingStep = ({ state, connection }) => (
  <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} className="glass-card w-full max-w-xl p-8 text-center sm:p-12" data-testid="waiting-step">
    <div className="relative mx-auto mb-10 h-32 w-32" data-testid="waiting-indicator">
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="absolute inset-0 rounded-full border"
          style={{ borderColor: "var(--brand)" }}
          initial={{ scale: 0.4, opacity: 0.8 }}
          animate={{ scale: 1.25, opacity: 0 }}
          transition={{ duration: 2.4, repeat: Infinity, delay: i * 0.8, ease: "easeOut" }}
        />
      ))}
      <motion.div
        className="absolute inset-8 rounded-full"
        style={{ background: "radial-gradient(circle, var(--brand) 0%, transparent 70%)" }}
        animate={{ scale: [1, 1.08, 1], opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
    <p className="text-lg leading-relaxed text-slate-100 md:text-xl" data-testid="waiting-message">
      Recebemos sua solicitação. Aguarde enquanto verificamos a disponibilidade das informações.
    </p>
    <div className="mt-8 flex flex-col items-center gap-3 text-sm text-slate-400">
      <span>Protocolo <span className="font-mono-x text-slate-200" data-testid="waiting-protocol">{state.protocolo}</span></span>
      {state.company?.razao_social && (
        <span className="max-w-md text-base font-semibold text-slate-100" data-testid="waiting-razao-social">{state.company.razao_social}</span>
      )}
      {state.company_lookup === "PENDENTE" && <span className="animate-pulse text-slate-500" data-testid="waiting-company-loading">Identificando empresa…</span>}
      <span>{state.tipo === "PF" ? "CPF" : "CNPJ"} <span className="font-mono-x text-slate-200" data-testid="waiting-cnpj">{state.cnpj_fmt}</span></span>
      <ConnectionPill status={connection} />
    </div>
  </motion.div>
);
